import * as types from './types'
import storage from '@/Plugins/storage'
import moment from 'moment'

export default {
  [types.RESET_PAGER](state) {
    state.pager = {
      pageSize: 10,
      orderBy: 'asc',
      sortBy: 'id',
      search: null,
      total: 0,
      page: 1,
      pages: 1,
    }
  },
  [types.SET_PAGER](state, data) {
    console.log('Set Pager', data)
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.SET_CHECKED](state, data) {
    state.isChecked = false
  },
  [types.RESET_APPLICATION](state, data) {
    state.application = JSON.parse(JSON.stringify(state.defaultApplication))
    state.application.releaseDate = moment().format('YYYY-MM-DD')
    console.log('Reset Application', state.application)
  },
  [types.RESET_ASSESSMENT](state, data) {
    state.assessment = JSON.parse(JSON.stringify(state.defaultAssessment))
    console.log('Reset Assessment', state.assessment)
  },
  [types.RESET_SETTING](state, data) {
    state.setting = JSON.parse(JSON.stringify(state.defaultSetting))
    if (data !== undefined && data !== null) {
      state.setting = data
    }
    console.log('Reset Setting', state.setting)
  },
  [types.SET_STATEPROVINCES](state, data) {
    state.stateprovinces = []
    if (data !== undefined && data !== null) {
      state.stateprovinces = data
    }
    storage.session.setItem(
      types.STORE_STATEPROVINCES,
      JSON.stringify(state.stateprovinces)
    )
  },
  [types.SET_TIMEZONES](state, data) {
    state.timezones = null
    if (data !== undefined && data !== null) {
      state.timezones = data
    }
    storage.session.setItem(
      types.STORE_TIMEZONES,
      JSON.stringify(state.timezones)
    )
  },
  [types.SET_APPLICATIONS](state, data) {
    state.applications = []
    if (data !== undefined && data !== null) {
      state.applications = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
  },
  [types.SET_APPLICATION](state, data) {
    state.application = null
    if (data !== undefined && data !== null) {
      state.application = data
    }
  },
  [types.SET_APPLICATION_DATA](state, data) {
    switch (data.name) {
      case 'id': {
        state.application.id = data.value
        break
      }
      case 'name': {
        state.application.name = data.value
        break
      }
      case 'appKey': {
        state.application.appKey = data.value
        break
      }
      case 'version': {
        state.application.version = data.value
        break
      }
      case 'OS': {
        state.application.OS = data.value
        break
      }
      case 'isRequired': {
        state.application.isRequired = parseInt(data.value)
        break
      }
      case 'releaseDate': {
        state.application.releaseDate = data.value
        break
      }
      case 'title': {
        state.application.title = data.value
        break
      }
      case 'message': {
        state.application.message = data.value
        break
      }
    }
  },
  [types.SET_ASSESSMENT_TYPES](state, data) {
    state.assessmentTypes = []
    if (data !== undefined && data !== null) {
      state.assessmentTypes = data
    }
  },
  [types.SET_ASSESSMENTS](state, data) {
    state.assessments = []
    if (data !== undefined && data !== null) {
      state.assessments = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
    console.log('Got Assessments', state.assessments)
  },
  [types.SET_ASSESSMENT](state, data) {
    state.assessment = null
    if (data !== undefined && data !== null) {
      state.assessment = data
    }
  },
  [types.SET_ASSESSMENT_DATA](state, data) {
    switch (data.name) {
      case 'id': {
        state.assessment.id = data.value
        break
      }
      case 'assessmentType': {
        state.assessment.assessmentType = data.value
        break
      }
      case 'instructions': {
        state.assessment.instructions = data.value
        break
      }
      case 'testType': {
        state.assessment.testType = data.value
        break
      }
      case 'url_1': {
        state.assessment.url_1 = data.value
        break
      }
      case 'url_2': {
        state.assessment.url_2 = data.value
        break
      }
    }
  },
  [types.SET_NORMS](state, data) {
    state.assessmentNorms = []
    if (data !== undefined && data !== null) {
      state.assessmentNorms = data.data
    }
    console.log('Got Assessment Norms', state.assessmentNorms)
  },
  [types.SET_SETTINGS](state, data) {
    state.settings = []
    if (data !== undefined && data !== null) {
      state.settings = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
    console.log('Got Settings', state.settings)
  },
  [types.SET_SETTING](state, data) {
    state.setting = null
    if (data !== undefined && data !== null) {
      state.setting = data
    }
  },
  [types.SET_SETTING_DATA](state, data) {
    switch (data.name) {
      case 'id': {
        state.setting.id = data.value
        break
      }
      case 'Name': {
        state.setting.Name = data.value
        break
      }
      case 'Classification': {
        state.setting.Classification = data.value
        break
      }
      case 'TextValue': {
        state.setting.TextValue = data.value
        break
      }
      case 'Value': {
        state.setting.Value = data.value
        break
      }
      case 'IsInactive': {
        state.setting.IsInactive = data.value
        break
      }
      case 'Sort': {
        state.setting.Sort = data.value
        break
      }
      case 'orgid': {
        state.setting.orgid = data.value
        break
      }
    }
  },
  [types.SET_BITEMPLATE](state, template) {
    state.selectedBiTemplate = template
  },
  [types.SET_BITEMPLATE_DATA](state, data) {
    switch (data.name) {
      case 'newTemplate': {
        state.selectedBiTemplate = state.defaultBiTemplate
        break
      }
      case 'updateTemplate': {
        state.selectedBiTemplate.name = data.value
        let maxId = 0
        if (state.biTemplates) {
          if (state.biTemplates.length > 0) {
            maxId = Math.max(...state.biTemplates.map((x) => x.id))
            maxId++
          }
          state.biTemplates.push(state.selectedBiTemplate)
        }
        state.selectedBiTemplate.id = maxId
        break
      }
      case 'removeTemplate': {
        if (state.biTemplates) {
          state.biTemplates = state.biTemplates.filter(
            (x) => parseInt(x.id) !== parseInt(data.value)
          )
        }
        break
      }
      case 'setTemplate': {
        if (state.biTemplates) {
          state.selectedBiTemplate = state.biTemplates.find(
            (x) => parseInt(x.id) === parseInt(data.value)
          )
        }
        break
      }
      case 'column': {
        if (state.biTemplates) {
          let found = state.biTemplates.find(
            (x) => parseInt(x.id) === parseInt(state.selectedBiTemplate.id)
          )
          if (found) {
            found.column = data.value
          }
        }
        break
      }
      case 'range': {
        if (state.biTemplates) {
          let found = state.biTemplates.find(
            (x) => parseInt(x.id) === parseInt(state.selectedBiTemplate.id)
          )
          if (found) {
            let maxId = 0
            if (found.ranges.length > 0) {
              maxId = Math.max(...found.ranges.map((x) => x.id))
              maxId++
            }
            found.ranges.push({
              id: maxId,
              min: data.value.min,
              max: data.value.max,
            })
          }
        }
        break
      }
      case 'rangeMessage': {
        if (state.biTemplates) {
          let found = state.biTemplates.find(
            (x) => parseInt(x.id) === parseInt(state.selectedBiTemplate.id)
          )
          if (found) {
            let foundRange = found.ranges.find(
              (x) => parseInt(x.id) === parseInt(data.value.id)
            )
            if (foundRange) {
              foundRange.message = data.value.value
            }
          }
        }
        break
      }
      case 'removeRange': {
        if (state.biTemplates) {
          let found = state.biTemplates.find(
            (x) => parseInt(x.id) === parseInt(state.selectedBiTemplate.id)
          )
          if (found) {
            found.ranges = found.ranges.filter(
              (x) => parseInt(x.id) !== parseInt(data.value)
            )
          }
        }
        break
      }
      case 'clipText': {
        if (state.biTemplates) {
          let found = state.biTemplates.find(
            (x) => parseInt(x.id) === parseInt(state.selectedBiTemplate.id)
          )
          if (found) {
            let foundRange = found.ranges.find(
              (x) => parseInt(x.id) === parseInt(data.id)
            )
            if (foundRange) {
              let maxId = 0
              if (foundRange.clipTexts) {
                if (foundRange.clipTexts.length > 0) {
                  maxId = Math.max(...foundRange.clipTexts.map((x) => x.id))
                  maxId++
                }
              } else {
                foundRange.clipTexts = []
              }
              foundRange.clipTexts.push({
                id: maxId,
                text: data.value,
              })
            }
          }
        }
        break
      }
      case 'removeClipText': {
        if (state.biTemplates) {
          let found = state.biTemplates.find(
            (x) => parseInt(x.id) === parseInt(state.selectedBiTemplate.id)
          )
          if (found) {
            let foundRange = found.ranges.find(
              (x) => parseInt(x.id) === parseInt(data.id)
            )
            if (foundRange) {
              foundRange.clipTexts = foundRange.clipTexts.filter(
                (x) => parseInt(x.id) !== parseInt(data.value)
              )
            }
          }
        }
        break
      }
    }
  },
  [types.SET_BITEMPLATES](state, data) {
    state.setting = null
    state.selectedBiTemplate = null
    state.biTemplates = []
    if (data !== undefined && data !== null) {
      state.setting = data
      if (data.TextValue) {
        state.biTemplates = JSON.parse(data.TextValue)
        state.biTemplates.forEach((element) => {
          element.isChanged = false
          if (element.ranges) {
            element.ranges.forEach((range) => {
              range.message = null
            })
          }
        })
      }
    }
    console.log('Got BiTemplates', state.biTemplates)
  },
}
